<vpg-media-thumbnail-image
    [id]="id"
    [screenReaderText]="title"
    [image]="image"
    [playButton]="playButton"
    class="recommendation-card-media-image">
    <vpg-media-thumbnail-progress
        [id]="id"
        [progress]="progress" />
</vpg-media-thumbnail-image>
